import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IdentityUserDto } from '@volo/abp.ng.identity/proxy';

@Injectable({ providedIn: 'root' })
export class UserSkillDialogService {
  private readonly _open$ = new Subject<IdentityUserDto>();
  readonly open$ = this._open$.asObservable();

  private readonly _skillsSaved$ = new Subject<void>();
  readonly skillsSaved$ = this._skillsSaved$.asObservable();

  open(user: IdentityUserDto): void {
    this._open$.next(user);
  }

  notifySkillsSaved(): void {
    this._skillsSaved$.next();
  }
}
